<avi-state-page>
    <avi-state-page_main-content>
        <avi-page-header headerText="{{ l10nKeys.headerLabel | vtranslate }}"></avi-page-header>
        <avi-collection-data-grid [config]="networkSecurityPolicyGridConfig"></avi-collection-data-grid>
    </avi-state-page_main-content>
</avi-state-page>
